// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ClsInboundSurveyDetail } from './clsInboundSurveyDetail.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClsInboundSurvey {
    'surveyName'?: string;
    'surveyDetails'?: Array<ClsInboundSurveyDetail>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClsInboundSurvey>> = [
        {
            "name":     "surveyName",
            "baseName": "surveyName",
            "type":     "string"
        },
        {
            "name":     "surveyDetails",
            "baseName": "surveyDetails",
            "type":     "Array<ClsInboundSurveyDetail>"
        },
    ];

    static getAttributeTypeMap() {
        return ClsInboundSurvey.attributeTypeMap;
    }
}
